import { formatInTimeZone } from "date-fns-tz";
import { Card, Icon } from "@/components/atoms";
import { useCountryConfig } from "@/hooks/useCountryConfig";
import { BookingDetails } from "@/redux/slices/booking/types";
import { kmToUnit } from "@/utils";
import { DetailField } from "../../../common/DetailField";

interface DistanceSectionProps {
  booking: BookingDetails;
}

export const DistanceSection = ({ booking }: DistanceSectionProps) => {
  const { distance, dates } = booking;
  const { config } = useCountryConfig();

  /*
   * Both distances arrive from the API in kilometres whatever the operator's country — the backend
   * stores and calculates metric, and `distance_unit` only says how to present it. A US or GB
   * operator reads their own trips in miles; everyone else sees exactly what they saw before.
   */
  const formatDistance = (km: number) => `${kmToUnit(km, config.distanceUnit, 1).toFixed(1)} ${config.distanceUnit}`;

  return (
    <Card className="space-y-3 p-2.5">
      <DetailField
        leading={<Icon name="Routing" size="lg" className="text-neutral-dark-gray" />}
        label="Actual Distance"
        value={distance?.actualDistance ? formatDistance(distance.actualDistance) : "-"}
      />

      <DetailField
        leading={<Icon name="Routing" size="lg" className="text-neutral-dark-gray" />}
        label="Estimated Distance"
        value={distance?.estimatedDistance ? formatDistance(distance.estimatedDistance) : "-"}
      />

      <DetailField
        leading={<Icon name="TickCircle" size="lg" className="text-neutral-dark-gray" />}
        label="Driver Closed Job"
        value={dates.driverCloseJob ? formatInTimeZone(new Date(dates.driverCloseJob), dates.timezone, "h:mm:ss a") : "-"}
      />
    </Card>
  );
};
